module.exports = __webpack_public_path__ + "img/home_pic_3.5_3.9e6ba780.webp";